export class UserModel {
    /** username = null for not logged in users */
    public username: string | null;

    public token: string;
    public refreshToken: string;
    public startDate: string;
    public userId: string | null;

    constructor(username: string | null, token: string, refreshToken: string, startDate: string, userId: string | null = null) {
        this.username = username;
        this.token = token;
        this.refreshToken = refreshToken;
        this.startDate = startDate;
        this.userId = userId;
    }
}